import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteCommissionModal = ({
    setIsDeleteCommissionModal,
    selectedData,
    deleteCommissionLoading,
    deleteCommissionMutate,
}) => {
    const handleDeleteSubmit = () => {
        deleteCommissionMutate({
            id: selectedData?.id,
            ...(selectedData?.isPaid === 1 && {
                expenseId: selectedData?.expenseId
            })
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteCommissionModal}
            title="Delete Staff Commission"
        >
            <WarningText>
                Please confirm if you want to delete the commission assigned to this staff member name '{selectedData?.staffName}'.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4 mt-8">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteCommissionModal(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteCommissionLoading}
                    className="border border-rose-600 bg-white text-rose-600 hover:bg-rose-600 hover:text-white"
                >
                    {deleteCommissionLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteCommissionModal;
